define( function() {
	"use strict";

	return Date.now();
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/ajax/var/nonce.js
 ** module id = 286
 ** module chunks = 0
 **/